import Vue from "vue";
import Vuex from "vuex";
import axios from "./axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    miniCompanies: [],
    miniCompaniesMap: {},
    provinces: [],
    cities: {},
    areas: {},
    levels: [],//客户等级
    taxTypes: [],//税务性质
    statuses: [],//公司状态
    contractTypes: [],//合同性质
    showLoading: false,//是否显示loading,
    companyId:null,//公司列表中，某个id对应的所有合同
    firms:[],//事务所列表
    notifications:[],//通知列表
  },
  getters: {
    // Compute derived state based on the current state. More like computed property.
    showLoading: state => state.showLoading,
    companyId:state=>state.companyId,
  },
  mutations: {
    setCompanyId(state, id) {
      state.companyId = id;
    },
    setLoading(state, flag) {
      state.showLoading = flag;
    },
    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
    setFirms(state, firms) {
      state.firms = firms;
    },
    setMiniCompanies(state, miniCompanies) {
      state.miniCompanies = miniCompanies;
    },
    setMiniCompaniesMap(state, miniCompaniesMap) {
      state.miniCompaniesMap = miniCompaniesMap;
    },
    setProvinces(state, provinces) {
      state.provinces = provinces;
    },
    setCities(state, {province, cities}) {
      state.cities[province] = cities;
    },
    setAreas(state, {province, city, areas}) {
      state.areas[province + "," + city] = areas;
    },
    setLevels(state, levels) {
      state.levels = levels;
    },
    setTaxTypes(state, taxTypes) {
      state.taxTypes = taxTypes;
    },
    setStatuses(state, statuses) {
      state.statuses = statuses;
    },
    setContractTypes(state, contractTypes) {
      state.contractTypes = contractTypes;
    }
  },
  actions: {
    setCompanyId({commit},id) {
      commit('setCompanyId', id);
    },
    setLoading({commit},flag) {
      commit('setLoading', flag);
    },
    fetchNotifications({commit},cb){
      axios
        .get("/notifications")
        .then(response => {
          let results = response.data.data;
          commit("setNotifications", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchFirms({commit},cb){
      axios
        .get("/firms")
        .then(response => {
          let results = response.data.data.map(c => {
            return {value: c.firmId, text: c.name};
          });
          commit("setFirms", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchMiniCompanies({commit}, {role,cb}) {
      let url='';
      if(role==='user'){
        url='me';
      }else{
        url='minimum';
      }

      axios
        .get("/companies/"+url)
        .then(response => {
         let dataArr=[];
         if(role==='user'){
           dataArr.push(response.data);
         }else{
           dataArr = response.data;
         }


          let results = dataArr.map(c => {
            return {value: c.companyId, text: c.name};
          });
          let resultsMap = results.reduce(function (map, obj) {
            map[obj.value] = obj.text;
            return map;
          }, {});
          // console.log(results);
          // console.log(resultsMap);
          commit("setMiniCompanies", results);
          commit("setMiniCompaniesMap", resultsMap);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchProvinces({commit}, cb) {
      axios
        .get("/provinces")
        .then(response => {
          let results = response.data;
          commit("setProvinces", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchCities({state, commit}, {province, callback}) {
      if (province in state.cities) {
        callback(state.cities[province]);
      } else {
        axios
          .get("/provinces/" + province + "/cities")
          .then(response => {
            let results = response.data;
            commit("setCities", {province: province, cities: results});
            if (callback) {
              callback(results);
            }
          })
          .catch(() => {
          });
      }
    },
    fetchAreas({state, commit}, {province, city, callback}) {
      let key = province + "," + city;
      if (key in state.areas) {
        callback(state.areas[key]);
      } else {
        axios
          .get("/provinces/" + province + "/cities/" + city + "/areas")
          .then(response => {
            let results = response.data;
            commit("setAreas", {
              province: province,
              city: city,
              areas: results
            });
            if (callback) {
              callback(results);
            }
          })
          .catch(() => {
          });
      }
    },
    fetchLevels({commit}, cb) {
      axios
        .get("/lookups/company/levels")
        .then(response => {
          let results = response.data;
          commit("setLevels", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchTaxTypes({commit}, cb) {
      axios
        .get("/lookups/company/tax-types")
        .then(response => {
          let results = response.data;
          commit("setTaxTypes", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchStatuses({commit}, cb) {
      axios
        .get("/lookups/company/statuses")
        .then(response => {
          let results = response.data;
          commit("setStatuses", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
    fetchContractTypes({commit}, cb) {
      axios
        .get("/lookups/contract/types")
        .then(response => {
          let results = response.data;
          commit("setContractTypes", results);
          if (cb) {
            cb(results);
          }
        })
        .catch(() => {
        });
    },
  }
});
